export const SECTION_LABELS = {
  summary: 'Professional Summary',
  key_highlights: 'Key Highlights',
  skills: 'Core Skills',
  tools_technologies: 'Key Tools & Technologies',
  experience: 'Past Companies & Experience',
  projects: 'Key Projects',
  awards: 'Awards & Recognitions',
  certifications: 'Certifications',
  education: 'Academics & Education',
  publications: 'Publications & Talks',
  languages: 'Spoken Languages',
};

// The set of section keys we render editors for, in display order.
export const SECTION_ORDER = [
  'summary',
  'key_highlights',
  'skills',
  'tools_technologies',
  'experience',
  'projects',
  'awards',
  'certifications',
  'education',
  'publications',
  'languages',
];

export const REFINE_MODE_LABELS = {
  tighten: { label: 'Tighten wording', hint: 'Polish current content (no new facts)' },
  re_extract: { label: 'Re-extract from PDF', hint: 'Re-parse from the original resume' },
  enhance: { label: 'Enhance + expand', hint: 'Light enrichment (acronyms, verbs)' },
};
